module.exports = __webpack_public_path__ + "img/eficiencia.49644709.png";